import React from 'react';
import { get } from 'lodash';
import { t } from 'i18n';

export const formatErrorMessage = (err) => {
  const status = get(err, 'status');
  const title = get(err, 'title', t('common.error'));
  const detail = get(err, 'message', t('common.error'));
  const errorMessage = (
    <div>
      <div>{`${title}`}</div>
      <div>{`${detail}`}</div>
      <div>{`${status ? `${t('common.status')}: ${status}` : ''}`}</div>
    </div>
  );

  return {
    message: errorMessage,
    status,
    title,
    detail,
  };
};
